import useStyles from './styles';

export function Column({ children }: CommonGridProps) {
  const classes = useStyles();

  return <div className={classes.column}>{children}</div>;
}

export function Row({
  children,
  justifyContent = 'center',
  alignItems = 'center',
}: CommonGridProps) {
  const classes = useStyles();

  return (
    <div className={classes.row} style={{ justifyContent, alignItems }}>
      {children}
    </div>
  );
}
